export enum OcppSecurityProfile {
  None = 0,
  Unsecured = 1,
  Secured = 2,
  Signed = 3,
}
